export default __webpack_public_path__ + "images/d0c31012e5bdbd22d581f604917e7c31.svg";